<template>
<div class="incomeFlow">
   <el-card class="box-card">
    <div slot="header" class="clearfix">
      <div style="float:left;">
        <el-button type="text" style="font-size:17px;">金额：{{totalMoney}}</el-button>
      </div>
      <span style="line-height: 36px; text-align: center;">收入流水</span>
      <div style="float:right">

        <el-select v-model="alarmType" placeholder="账号级别" class="acclevel">
          <el-option
            v-for="item in alarmTypes"
            :key="item.name"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <!--<el-select v-model="alarmStatus" placeholder="状态">
          <el-option
            v-for="item in alarmStatuses"
            :key="item.value"
            :label="item.value"
            :value="item.key">
          </el-option>
        </el-select>-->
        <el-date-picker
          v-model="startTime"
          value-format="yyyy-mm-dd"
          type="date"
          placeholder="开始日期">
        </el-date-picker>
        <el-date-picker
          v-model="endTime"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期">
        </el-date-picker>
        <el-button type="success" @click="btnSearch">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      height="520"
      style="width: 100%">
      <el-table-column
        prop="id"
        header-align="center"
        min-width="80"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="amount"
        header-align="center"
        min-width="80"
        label="金额/元">
        <template scope="scope">
          <span>{{(scope.row.amount/100).toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        min-width="200"
        label="订单时间">
      </el-table-column>
      <el-table-column
        prop="oid"
        header-align="center"
        min-width="250"
        label="订单号">
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      data () {
        return {
          deviceData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          endTime: '',
          startTime: '',
          alarmTypes: [],
          alarmType: '',
          alarmStatuses: [{
            key: '',
            value: '全部类型'
          }, {
            key: 'SBZ_INCOME',
            value: '支付收入'
          }, {
            key: 'SBZ_AD_INCOME',
            value: '广告收入'
          }, {
            key: 'SBZ_FREE_INCOME',
            value: '免费出货收入'
          }],
          alarmStatus: '',
          deviceCode: '',
          date: '',
          totalMoney: '',
          fee: 0
        }
      },
      created: function () {
        this.pageNo = 1
        this.getAccountList()
        this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.startTime, this.endTime)
      },
      methods: {
        btnSearch () {
          this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.startTime, this.endTime)
        },
        getAccountList () {
          var _this = this
          $axios.get('/system/queryAcccount', null, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              for (let i = 0; i < res.resultData.list.length; i++) {
                var usertype = res.resultData.list[i].user_type === 1 ? '代理商' : '设备主'
                _this.alarmTypes.push({
                  id: res.resultData.list[i].id,
                  name: usertype + '-' + (res.resultData.list[i].nickName!=null?res.resultData.list[i].nickName:res.resultData.list[i].user_name)
                })
              }
             
            }
          })
        },
        queryDeviceList (tPageNo, tPageSize, tFaultId, tStatus, startTime, endTime) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            userId: tFaultId + '',
            payType: tStatus,
            startTime: startTime === '' ? '' : new Date(startTime).getFullYear() + '-' + (new Date(startTime).getMonth() + 1) + '-' + new Date(startTime).getDate(),
            endTime: endTime === '' ? '' : new Date(endTime).getFullYear() + '-' + (new Date(endTime).getMonth() + 1) + '-' + new Date(endTime).getDate()
          }
          this.table_loading = true
          this.deviceData = []
          $axios.post('/fx/queryTurnover', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                _this.deviceData = res.resultData.list
                _this.totalMoney = (res.resultData.totalMoney / 100).toFixed(2) + '元'
                _this.fee = res.resultData.fee/100

                for (var i=0; i<res.resultData.list.length; i++){
                  res.resultData.list[i].amount = res.resultData.fee
                }
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.startTime, this.endTime)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.startTime, this.endTime)
        }
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .incomeFlow {
        .el-select .el-input {
          width: 110px;
        }
        .acclevel .el-input{
          width: 200px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/fxshop/fxIncomeSubsidy.vue